/* Project Import will be here */
import {
  loginApi,
  loginJnJApi,
  loginNewApi,
  newUserApi,
  // updateMobileNoApi,
  requestMobChangeOTPApi,
  verifyOtpApi,
  forgotPasswordApi,
  changePasswordApi,
  signUpWithProfileApi,
  checkLoginIdExistApi
} from "../services/session";
import {
  ILoginParams,
  INewLoginParams,
  IJnJLoginParams,
  INewUserParams,
  IRequestMobChangeParams,
  // IUpdateMobileNoParams,
  IForgotPassParams,
  IVerifyOtpActionParams,
  ISignUpActionParams,
  ISignUpWithProfile,
  INewLoginChangePasswordParams
} from "models/sessionModels";
import {
  navigateToHome,
  navigateToIndex,
  navigateToRegister,
  navigateToRegisterVerifyOtp,
  navigateToRegisterProfile,
  navigateToForgotPasswordVerification,
  // navigateToChangePassword,
  // navigateToResetDefaultPassword,
  navigateToManageWholesalers
} from "app/navigation";
import { authTokenKey } from "services/index";
import { getErrorObject, errorToast } from "utilities/utils";
import { toggleLoginOtpVerificationModal } from "./sessionOtpVerification";
import { loadAppSettingConfig, clearDispatchInstance } from "reducers/common/appSettings";
import { navigateToDirectLink } from "reducers/common";
import { showMsgFromJson } from "reducers/common";
import Constants from "../utilities/appConstants";
import { GALogin, GALogout, GASetUserId } from "hooks/googleAnalyticsHooks";
import { getWholesalerList } from "reducers/wholesalers";

/* TODO: Need to complete the push notification then enable for commit */
/* import { updateFcmToken } from "reducers/localStore"; */

/* Project Import will be here */

export const types = {
  LOGIN_REQUEST: "session/LOGIN_REQUEST",
  LOGIN_SUCCESS: "session/LOGIN_SUCCESS",
  LOGIN_FAILURE: "session/LOGIN_FAILURE",
  CHECK_LOGIN_ID_REQUEST: "session/CHECK_LOGIN_ID_REQUEST",
  CHECK_LOGIN_ID_SUCCESS: "session/CHECK_LOGIN_ID_SUCCESS",
  CHECK_LOGIN_ID_FAILURE: "session/CHECK_LOGIN_ID_FAILURE",
  SEND_OTP_REQUEST: "session/SEND_OTP_REQUEST",
  SEND_OTP_SUCCESS: "session/SEND_OTP_SUCCESS",
  SEND_OTP_FAILURE: "session/SEND_OTP_FAILURE",
  VERIFY_OTP_REQUEST: "session/VERIFY_OTP_REQUEST",
  VERIFY_OTP_SUCCESS: "session/VERIFY_OTP_SUCCESS",
  VERIFY_OTP_FAILURE: "session/VERIFY_OTP_FAILURE",
  SIGN_UP_REQUEST: "session/SIGN_UP_REQUEST",
  SIGN_UP_SUCCESS: "session/SIGN_UP_SUCCESS",
  SIGN_UP_FAILURE: "session/SIGN_UP_FAILURE",
  CHANGE_PASSWORD_REQUEST: "session/CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "session/CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "session/CHANGE_PASSWORD_FAILURE",
  RESET_FORM_STATE: "session/RESET_FORM_STATE",
  SET_USER_LOGIN_FIRST_TIME: "session/SET_USER_LOGIN_FIRST_TIME",
  CLOSE_SESSION_LOADER: "session/CLOSE_LOADER",
  LOG_OUT: "session/LOG_OUT"
};

const initialState = {
  isLoading: false,
  error: null,
  token: null,
  loginId: null,
  userLoginAtFirstTime: false,
  showPasswordForm: false,
  isLoginWithPassword: false,
  tempUser: null,
  tempToken: null
};

export const session = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
    case types.CHECK_LOGIN_ID_REQUEST:
    case types.SEND_OTP_REQUEST:
    case types.VERIFY_OTP_REQUEST:
    case types.CHANGE_PASSWORD_REQUEST:
    case types.SIGN_UP_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case types.LOGIN_SUCCESS:
    case types.SIGN_UP_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        userLoginAtFirstTime: false,
        tempUser: null,
        tempToken: null
      };

    case types.CHECK_LOGIN_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginId: action.payload.loginId,
        showPasswordForm: action.payload.isLoginWithPassword,
        isLoginWithPassword: action.payload.isLoginWithPassword,
      };

    case types.SEND_OTP_SUCCESS:
      const { token, loginId, auth } = action.payload;
      return {
        ...state,
        error: null,
        isLoading: false,
        token,
        loginId,
        auth
      };

    case types.VERIFY_OTP_SUCCESS:
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false
      };

    case types.LOGIN_FAILURE:
    case types.CHECK_LOGIN_ID_FAILURE:
    case types.SEND_OTP_FAILURE:
    case types.VERIFY_OTP_FAILURE:
    case types.CHANGE_PASSWORD_FAILURE:
    case types.SIGN_UP_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isLoading: false
      };

    case types.RESET_FORM_STATE:
      return {
        ...state,
        error: null
      };

    case types.LOG_OUT:
      return initialState;

    case types.SET_USER_LOGIN_FIRST_TIME:
      return {
        ...state,
        ...action.payload
      };

    case types.CLOSE_SESSION_LOADER:
      return {
        ...state,
        isLoading: false
      };

    default:
      return state;
  }
};

/* New login flow */
export const loginNew = (data: INewLoginParams) => {
  return async (dispatch, getState) => {

    /* Initiate the request and show the loader */
    dispatch({ type: types.LOGIN_REQUEST });

    try {
      const response = await loginNewApi(data);
      const user = response.data.Data;
      const token = response.headers[authTokenKey];

      /* Get the app settings configurations */
      await dispatch(loadAppSettingConfig(token));

      /* If the retailer login at first time redirect the retailer to get mobile number screen */
      if (user.isfirsttimelogin) {
        dispatch({
          type: types.SET_USER_LOGIN_FIRST_TIME,
          payload: {
            userLoginAtFirstTime: true,
            tempUser: user,
            tempToken: token,
            showPasswordForm: false,
            isLoading: false
          }
        });
      }
      /* Send OTP for otpAuthForEveryLogin */
      else if (!getState().session.isLoginWithPassword && user && !user.isfirsttimelogin && getState().appSettings.otpAuthAfterLogin && getState().appSettings.otpAuthForEveryLogin) {
        /* Close loader */
        dispatch({ type: types.CLOSE_SESSION_LOADER });
        dispatch(toggleLoginOtpVerificationModal(user, token, user.mobile));
      }
      /* Else the retailer proceed the default flow */
      else {
        /* Check for GA is enabled */
        if (window.isEnableGA) {
          /* Set user id to GA */
          GASetUserId(user.retailerid);

          /* Track login event in Google Analytics */
          GALogin(user.mobile);
        }

        /* Else with out any verification the user moved to home page */
        dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token } });

        /* Distributor selection -After distributor selection the retailer will be redirect to home or place order page */
        dispatch(getWholesalerList(true));
      }
    }
    catch (error) {
      dispatch(navigateToIndex());
      dispatch(promiseCatchBlock(error, types.LOGIN_FAILURE));
    }
  };
};

/* Check the given login id is exist in the system */
export const checkLoginIdExist = (data: ILoginParams) => {
  return async (dispatch, getState) => {
    /* Initiate the request and show the loader */
    dispatch({ type: types.CHECK_LOGIN_ID_REQUEST });
    try {
      const response = await checkLoginIdExistApi(data);

      /* Check password or username/password based authentication */
      if (response.data.Data.isLoginWithPassword)
        dispatch({ type: types.CHECK_LOGIN_ID_SUCCESS, payload: response.data.Data });
      else
        dispatch(loginNew(data));
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.CHECK_LOGIN_ID_FAILURE));
    }
  };
};

/* Change the default password */
export const changeDefaultPassword = (data: INewLoginChangePasswordParams) => {
  return async (dispatch, getState) => {
    /* Initiate the request and show the loader */
    dispatch({ type: types.CHANGE_PASSWORD_REQUEST });
    try {
      await changePasswordApi(data, getState().session.tempToken);
      dispatch({ type: types.CHANGE_PASSWORD_SUCCESS });

      /* If the mobile number updated successfully proceed the retailer to access the application */
      dispatch(updateUserDetailsAndNavigateToHome(getState().session.tempUser, getState().session.tempToken));
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.CHANGE_PASSWORD_FAILURE));
    }
  };
};

/* Login functionality for JNJ and P&G customer */
export const loginJnJ = (data: IJnJLoginParams) => {
  return async (dispatch, getState) => {

    /* Initiate the request and show the loader */
    dispatch({ type: types.LOGIN_REQUEST });

    try {
      const response = await loginJnJApi(data);
      const user = response.data.Data;
      const token = response.headers[authTokenKey];

      /* Get the app settings configurations */
      await dispatch(loadAppSettingConfig(token));

      /* Check for OTP verification config and first time login */
      if (user && getState().appSettings.otpAuthAfterLogin && (user.isfirsttimelogin || getState().appSettings.otpAuthForEveryLogin)) {
        dispatch(toggleLoginOtpVerificationModal(user, token, data.mobileNo));
      }
      else {
        /* Check for GA is enabled */
        if (window.isEnableGA) {
          /* Set user id to GA */
          GASetUserId(user.retailerid);

          /* Track login event in Google Analytics */
          GALogin(user.mobile);
        }

        /* Else with out any verification the user moved to home page */
        dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token } });

        /* Navigate to query string landing page and focused tab */
        dispatch(navigateToDirectLink(data.query));
      }
    }
    catch (error) {
      dispatch(navigateToIndex());
      dispatch(promiseCatchBlock(error, types.LOGIN_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
export const login = (data: ILoginParams) => {
  return async dispatch => {
    dispatch({ type: types.LOGIN_REQUEST });
    try {
      const response = await loginApi(data);
      const user = response.data.Data;
      const auth = response.headers[authTokenKey];

      if (user && user.mobile && user.isfirsttimelogin) {
        dispatch({ type: types.LOGIN_SUCCESS, payload: { user, auth } });
        dispatch(navigateToRegisterVerifyOtp());
      } else if (user && !user.mobile && user.isfirsttimelogin) {
        dispatch({ type: types.LOGIN_SUCCESS, payload: { user, auth, loginId: data.loginId } });
        dispatch(navigateToRegister());
      } else {
        dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token: auth } });
        dispatch(navigateToHome());
      }
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.LOGIN_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
export const requestMobChangeOTP = (data: IRequestMobChangeParams) => {
  const { mobileno } = data;
  return async (dispatch, getState) => {
    dispatch({ type: types.SEND_OTP_REQUEST });
    try {
      const { auth } = getState().localStore;
      await requestMobChangeOTPApi({
        data,
        headers: { [authTokenKey]: auth }
      });

      dispatch({ type: types.SEND_OTP_SUCCESS, payload: { auth, loginId: mobileno } });
      dispatch(navigateToRegisterVerifyOtp());
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.SEND_OTP_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
// export const updateMobileNo = (data: IUpdateMobileNoParams) => {
//   const { otp } = data;
//   return async (dispatch, getState) => {
//     dispatch({ type: types.VERIFY_OTP_REQUEST });
//     try {
//       const { auth, loginId } = getState().localStore;
//       const valid_data = { mobileno: loginId, otp }
//       await updateMobileNoApi({
//         data: valid_data,
//         headers: { [authTokenKey]: auth }
//       });
//       dispatch({ type: types.VERIFY_OTP_SUCCESS });
//       dispatch(navigateToResetDefaultPassword());
//     } catch (error) {
//       dispatch(promiseCatchBlock(error, types.VERIFY_OTP_FAILURE));
//     }
//   };
// };

/* TODO: Unused method -  Need to check and remove */
export const newUser = (data: INewUserParams) => {
  const { loginId } = data;
  return async dispatch => {
    dispatch({ type: types.SEND_OTP_REQUEST });
    try {
      const response = await newUserApi(data);
      const token = response.headers[authTokenKey];
      dispatch({ type: types.SEND_OTP_SUCCESS, payload: { token, loginId } });
      dispatch(navigateToRegisterVerifyOtp());
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.SEND_OTP_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
export const verifyOtpNewUser = (data: IVerifyOtpActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.VERIFY_OTP_REQUEST });
    try {
      const { token } = getState().session;
      await verifyOtpApi({
        data,
        headers: { [authTokenKey]: token }
      });
      dispatch({ type: types.VERIFY_OTP_SUCCESS });
      dispatch(navigateToRegisterProfile());
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.VERIFY_OTP_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
// export const verifyExistMobileOtp = (data: IVerifyOtpActionParams) => {
//   return async (dispatch, getState) => {
//     dispatch({ type: types.VERIFY_OTP_REQUEST });
//     try {
//       const { auth } = getState().localStore;
//       await verifyOtpApi({
//         data,
//         headers: { [authTokenKey]: auth }
//       });
//       dispatch({ type: types.VERIFY_OTP_SUCCESS });
//       dispatch(navigateToResetDefaultPassword());
//     } catch (error) {
//       dispatch(promiseCatchBlock(error, types.VERIFY_OTP_FAILURE));
//     }
//   };
// };

/* TODO: Unused method -  Need to check and remove */
export const signUp = (data: ISignUpActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.SIGN_UP_REQUEST });
    try {
      const { token } = getState().session;
      await signUpWithProfileApi({
        data,
        headers: { [authTokenKey]: token }
      });
      dispatch({ type: types.SIGN_UP_SUCCESS, payload: { token } });
      dispatch(showMsgFromJson("common.alerts.success.profileRegistered", Constants.SUCCESS));
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch(promiseCatchBlock(error, types.SIGN_UP_FAILURE));
      throw message;
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
export const signUpWithSaveProfile = (data: ISignUpWithProfile) => {
  return async (dispatch, getState) => {
    const principals = getState().principals;
    const selectedPrinciple = principals.ids[0];
    if (!selectedPrinciple) {
      dispatch(showMsgFromJson("common.alerts.error.principleNotFound", Constants.ERROR));
      return Promise.reject(false);
    }
    try {
      await dispatch(
        signUp({
          ...data.signup,
          ...data.profile,
          PrincipalIds: [selectedPrinciple]
        })
      );
      dispatch(navigateToManageWholesalers({ redirectToHome: true }));
    } catch (error) {
      console.error(error);
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
export const forgotPassword = (data: IForgotPassParams) => {
  const { loginId } = data;
  return async dispatch => {
    dispatch({ type: types.SEND_OTP_REQUEST });
    try {
      const response = await forgotPasswordApi(data);
      const token = response.headers[authTokenKey];
      dispatch({ type: types.SEND_OTP_SUCCESS, payload: { token, loginId } });
      dispatch(navigateToForgotPasswordVerification());
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.SEND_OTP_FAILURE));
    }
  };
};

/* TODO: Unused method -  Need to check and remove */
// export const verifyOtpForgotPassword = (data: IVerifyOtpActionParams) => {
//   return async (dispatch, getState) => {
//     dispatch({ type: types.VERIFY_OTP_REQUEST });
//     try {
//       const { token } = getState().session;
//       await verifyOtpApi({
//         data,
//         headers: { [authTokenKey]: token }
//       });
//       dispatch({ type: types.VERIFY_OTP_SUCCESS });
//       dispatch(navigateToChangePassword());
//     } catch (error) {
//       dispatch(promiseCatchBlock(error, types.VERIFY_OTP_FAILURE));
//     }
//   };
// };

/* Logout the user from the application */
export const logOut = () => {
  return async (dispatch, getState) => {

    /* TODO: Need to complete the push notification then enable for commit */
    /* DeRegister the FMC token */
    /* await dispatch(updateFcmToken(null)); */

    /* Check for GA is enable */
    if (window.isEnableGA) {
      const loggedInUserDetails = getState().localStore.user;

      /* Track logout event in Google Analytics */
      GALogout(loggedInUserDetails.mobile);
    }

    dispatch({ type: types.LOG_OUT });

    /* Clear dispatch instance */
    dispatch(clearDispatchInstance());

    dispatch(navigateToIndex());
  };
};

export const resetFormState = () => {
  return dispatch => {
    dispatch({ type: types.RESET_FORM_STATE });
  };
};

/* Update user details and token after the successful OTP validation */
export const updateUserDetailsAndNavigateToHome = (user, token) => {
  return (dispatch, getState) => {

    /* Check for GA is enabled */
    if (window.isEnableGA) {
      /* Set user id to GA */
      GASetUserId(user.retailerid);

      /* Track login event in Google Analytics */
      GALogin(user.mobile);
    }

    /* Onboard success message */
    if (getState().session.userLoginAtFirstTime && !getState().session.isLoginWithPassword)
      dispatch(showMsgFromJson(`common.alerts.success.onboardingSuccess`, Constants.SUCCESS));
    else if (getState().session.userLoginAtFirstTime && getState().session.isLoginWithPassword)
      dispatch(showMsgFromJson(`common.alerts.success.changePasswordSuccess`, Constants.SUCCESS));

    dispatch({ type: types.LOGIN_SUCCESS, payload: { user, token } });

    /* Distributor selection -After distributor selection the retailer will be redirect to home or place order page */
    dispatch(getWholesalerList(true));
  };
};

const promiseCatchBlock = (error: any, type: string) => {
  return (dispatch) => {
    /* Extract the error message and error code from the response object */
    const { message, errorCode } = getErrorObject(error);

    dispatch({
      type: type,
      payload: { error: message }
    });

    /* If error code is exist show the error code message or show the error message returned by the API request */
    if (errorCode !== "")
      dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
    else
      errorToast({ content: message });
  }
};